export function getApiBaseUrl() {
  const configured =
    process.env.REACT_APP_API_BASE?.trim();

  if (configured) {
    return configured.replace(/\/+$/, "");
  }

  if (
    typeof window !== "undefined" &&
    (
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1"
    )
  ) {
    return "http://localhost:8080";
  }

  return "https://api.reignitespirit.com";
}

export const API_BASE_URL =
  getApiBaseUrl();